import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseActivityPanel_NotificationHistory_caseEmailHistory';

export default gql`
  query ${NAME} ($caseNumber: String!) {
    case (caseNumber: $caseNumber) {
      id
      emailHistory {
        edges {
          node {
            insertedAt
            caseEmailType
            recipientsEmails
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/NotificationHistory/withCaseNotificationHistory/caseEmailHistoryQuery.js